import React from 'react';
import { translate } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Fade from '@material-ui/core/Fade';
import './scss/style.scss';

const useStyles = makeStyles(() => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    paper: {
        display: 'flex',
        height: '100%',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center'
    }
}));

function ESIMOrderSuccessModal(props) {
    const classes = useStyles();

    return (
        <Modal
            open={props.open}
            onClose={props.onClose}
            classes={classes.modal}
            aria-labelledby="esim-order-success-title"
            aria-describedby="esim-order-success-description"
        >
            <Fade in={props.open}>
                <div className={classes.paper}>
                    <div className="dashboard-esim-success-modal">
                        <button type="button" className="dashboard-esim-success-modal-close" onClick={props.onClose}>
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.687 1.607L12.393 0.313 7 5.706 1.607 0.313 0.313 1.607 5.706 7 0.313 12.393 1.607 13.687 7 8.294 12.393 13.687 13.687 12.393 8.294 7 13.687 1.607Z" fill="#2E3131" />
                            </svg>
                        </button>

                        <div className="dashboard-esim-success-modal-icon" aria-hidden="true">
                            <div className="dashboard-esim-success-modal-icon-ring">
                                <div className="dashboard-esim-success-modal-icon-core">
                                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.375 20.625L6.75 15L8.5125 13.2375L12.375 17.0875L21.4875 7.9875L23.25 9.75L12.375 20.625Z" fill="white" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <h3 className="dashboard-esim-success-modal-title" id="esim-order-success-title">{props.t('eSIM hazırdır')}</h3>
                        <p className="dashboard-esim-success-modal-description" id="esim-order-success-description">
                            {props.countryFlag} {props.countryName} {props.planVolume} planınız alınıb və quraşdırılmağa hazırdır.
                        </p>

                        <div className="dashboard-esim-success-modal-actions">
                            <button type="button" className="dashboard-esim-success-modal-later" onClick={props.onLater || props.onClose}>
                                {props.t('Sonra quraşdır')}
                            </button>
                            <button type="button" className="dashboard-esim-success-modal-now" onClick={props.onInstallNow || props.onClose}>
                                {props.t('İndi quraşdır')}
                            </button>
                        </div>
                    </div>
                </div>
            </Fade>
        </Modal>
    );
}

export default translate('translation')(ESIMOrderSuccessModal);